module.exports = "https://cdn.dashboard.gifty.nl/5697/images/plane.svg?1641bc4936963950c3c54b2f62f5e44c";